import { createGeoResultStorage } from './geo-result-storage'
import { hydrateFromResult } from './geo-location-state'

export function hydrateGeoStateFromSessionStorage(storage: Storage): void {
	const geoStorage = createGeoResultStorage(storage)
	const geoResult = geoStorage.read()
	if (geoResult !== null) {
		hydrateFromResult(geoResult)
	}
}
